export default __webpack_public_path__ + "static/media/icon.c02067f4.svg";